import { Image } from '@/components/pdf/Image'

export const ImagePlaceholder = ({ src }: { src: string }) => {
  return (
    <div
      style={{ height: 180, width: 'auto', borderColor: '#818cf8' }}
      className="border"
    >
      <Image
        src={src}
        className="min-h-full h-full w-full"
        data-testid="draggable-image"
      />
    </div>
  )
}
